import { KEY_CONFIG } from './../config/key-config';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { BreadCrumbService } from '../ui-components/breadcrumb/breadcrumb.service';



@Injectable()
export class UtilityService {
  envConfig: any;
  successMessage: string = null;
  fanId: string;
  ranNum: number = 1;
  private dashboard = '/dashboard';
  private manageProduct = '/manageProduct';
  private manage = '/manageLicenses';
  private pageTitleConfig = {};
  private pageLoadChangeChecklist: BehaviorSubject<boolean>;
  

  constructor(private http: HttpClient, private breadCrumbService: BreadCrumbService, ) {
    this.envConfig = {};
    this.pageTitleConfig = {};
    this.pageLoadChangeChecklist = new BehaviorSubject<boolean>(false);
  }


  csvJSON(csv) {
    const lines = csv.split('\n')
    const result = []
    const headers = lines[0].split(',')

    for (let i = 1; i < lines.length; i++) {
      if (!lines[i])
        continue
      const obj = {}
      const currentline = lines[i].split(',')

      for (let j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j]
      }
      result.push(obj)
    }
    return JSON.stringify(result);
  }

  getJson(url) {
    // console.log(url);
    return this.http.get(url)
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        })
        , catchError(this.handleError));
  }


  setEnvConfig(envConfig) {
    this.envConfig = envConfig;
  }

  getEnvConfig() {
    return this.envConfig;
  }

  handleError(error) {
    return throwError('Server Error');
  }

  getQueryParameterByName(name: string, url: string): string {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  formatTelephoneNumber(val: string) {
    let value: string = val;
    // console.log(value);
    value = value.split('.').join('');
    if (value.length > 3 && value.length < 6) {
      value = value.replace(/(\w{3})/, '$1.');
    } else if (value.length === 6) {
      value = value.replace(/(\w{3})(\w{3})/, '$1.$2');
    } else if (value.length > 6 && value.length < 10) {
      value = value.replace(/(\w{3})(\w{3})/, '$1.$2.');
    } else if (value.length === 10) {
      value = value.replace(/(\w{3})(\w{3})(\w{4})/, '$1.$2.$3');
    } else if (value.length === 11) {
      value = value.replace(/(\w{3})(\w{3})(\w{4})(\w{1})/, '$1.$2.$3');
    } else if (value.length === 12) {
      value = value.replace(/(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3');
    } else if (value.length === 14) {
      value = value.substr(0, 12);
      value = value.replace(/(\w{3})(\w{3})(\w{4})(\w{2})/, '$1.$2.$3');
    }
    return value;
  }

  formatTelephoneNumberWithDash(val: string) {
    let value: string = val;
    value = value.split('-').join('');
    if (value.length > 1 && value.length <= 3) {
      value = value.replace(/(\w{1})/, '$1-');
    } else if (value.length > 3 && value.length < 5) {
      value = value.replace(/(\w{1})(\w{3})/, '$1-$2');
    } else if (value.length === 5) {
      value = value.replace(/(\w{1})(\w{3})/, '$1-$2-');
    } else if (value.length > 5 && value.length < 8) {
      value = value.replace(/(\w{1})(\w{3})(\w{2})/, '$1-$2-$3');
    } else if (value.length === 8) {
      value = value.replace(/(\w{1})(\w{3})(\w{3})/, '$1-$2-$3-');
    } else if (value.length > 8 && value.length < 12) {
      value = value.replace(/(\w{1})(\w{3})(\w{3})(\w{2})/, '$1-$2-$3-$4');
    } else if (value.length > 11) {
      value = value.substr(0, 11);
      value = value.replace(/(\w{1})(\w{3})(\w{3})(\w{2})/, '$1-$2-$3-$4');
    }
    return value;
  }

  validatePhoneNumber(data) {
    if (data.value.length > 0) {
      var input = data.value.split('.').join('');
      if (input.match('^[0-9\.\]{10}$')) {
        // validation passed
      } else {
        return {
          'checkPattern': true
        };
      }
    }
  }

  onFocusFormat(val, seperator) {
    if (seperator === 'dot') {
      val = val.split('.').join('');
    } else if (seperator === 'dash') {
      val = val.split('-').join('');
    }
    return val;
  }

  onBlurFormat(val, seperator) {
    if (seperator === 'dot') {
      val = this.formatTelephoneNumber(val);
    } else if (seperator === 'dash') {
      val = this.formatTelephoneNumberWithDash(val);
    }
    return val;
  }

  changeCursorPos(el, cursorPos, length) {
    if (length !== 5 && length !== 9) {
      // do nothing
    } else {
      cursorPos += 1;
    }
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', cursorPos);
      range.select();
    } else {
      if (el.setSelectionRange) {
        el.focus();
        el.setSelectionRange(cursorPos, cursorPos);
      } else {
        el.focus();
      }
    }
  }

  getCookie(name) {
    let dc = document.cookie;
    let prefix = name + '=';
    let begin = dc.indexOf('; ' + prefix);
    let end = null;
    if (begin === -1) {
      begin = dc.indexOf(prefix);
      if (begin !== 0) {
        return null;
      }
    } else {
      begin += 2;
      end = document.cookie.indexOf(';', begin);
      if (end === -1) {
        end = dc.length;
      }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
  }
  checkInstance(instance, permissionArray) {
    for (let perm of permissionArray) {
      // console.log('instance ' + instance);
      if (perm.instance === instance) {
        return !null;
      }
    }
    return null;
  }
  checkPagePermission(instance, permissionArray) {
    for (let perm of permissionArray) {
      // console.log('instance ' + instance);
      if (perm.instance === instance && perm.action === 'show') {
        return true;
      }
    }
    return false;
  }

  checkComponentPermission(instance, permissionArray) {
    for (let perm of permissionArray) {
      // console.log('instance ' + instance);
      if (perm.instance === instance && (perm.action === 'hide' || perm.action === 'disable')) {
        return false;
      }
    }
    return true;
  }

  checkComponentShowPermission(instance, permissionArray) {
    for (let perm of permissionArray) {
      // console.log('instance ' + instance);
      if (perm.instance === instance && perm.action === 'show') {
        return true;
      }
    }
    return false;

  }

  checkFieldPermission(instance, permissionArray) {
    for (let perm of permissionArray) {
      if (perm.instance === instance && (perm.action === 'read' || perm.action === 'hide' || perm.action === 'disable')) {
        // console.log(perm.instance + 'and' + perm.action);
        return true;
      }
    }
    return false;
  }

  getFocusableElements(element) {
    const focusableEls = element.nativeElement.
      querySelectorAll('a[href], area[href],' +
        ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    return focusableEls;
  }

  handleKeyPress(event, focusabbleElements) {
    const focussedEl = event.target;
    if (event.shiftKey && event.keyCode === KEY_CONFIG.tabKey) {
      if (focussedEl === focusabbleElements[0]) {
        event.preventDefault();
        focusabbleElements[focusabbleElements.length - 1].focus();
      }
    } else if (event.keyCode === KEY_CONFIG.tabKey) {
      console.log(focusabbleElements);

      if (focussedEl === focusabbleElements[focusabbleElements.length - 1]) {
        event.preventDefault();
        focusabbleElements[0].focus();
      }
    }

  }
  /** added for premier mock */
  getUserPermissions(permissions: any[]): string {
    var userPermission: string;
    console.log(permissions)
    for (let permissionType of permissions) {
      if (permissionType.level === 'GRANT') {
        userPermission = userPermission ? '_' : '' + permissionType.name.toUpperCase();
      }
    }
    console.log(userPermission)
    return userPermission ? userPermission : 'NONE';
  }

  setSuccessMessage(message) {
    this.successMessage = message;
  }

  getSuccessMessage() {
    return this.successMessage;
  }

  setSelectedFan(id) {
    this.fanId = id;
  }

  getSelectedFan() {
    return this.fanId;
  }

  getRandom() {
    this.ranNum++;
    return this.ranNum;
  }
  // page scroll to top position
  loadFocusOnTop() {
    const scrollingElement = document.scrollingElement || document.documentElement;
    scrollingElement.scrollTop = 0;
  }

  trimSpace(value) {
    return value = value.replace(/\s\s+/g, ' ');
  }

  /* getParentUrl(url) {
    let slashAvailable = 0, secondSlashIndex = 0;
    for (let i = 0; i < url.length; i++) {
      const char = url.charAt(i);
      if (char === '/') {
        if (slashAvailable === 1) {
          secondSlashIndex = i;
        }
        slashAvailable++;
      }
    }
    if (slashAvailable > 1) {
      url = url.substring(0, secondSlashIndex);
    } else {
      url = url.substring(0, url.length);
    }
    return url;
  }*/

  getParentUrl() {
    let parentUrl;
    let rowIndex;
    let breadCrumbs = this.breadCrumbService.getBreadCrumbs();
    let breadCrumbAlreadyExist = breadCrumbs.find(value => (value.routerLink === this.manageProduct));
    if (breadCrumbAlreadyExist === undefined) {
      breadCrumbAlreadyExist = breadCrumbs.find(subData => (subData.routerLink === this.manage));
      if (breadCrumbAlreadyExist === undefined) {
        breadCrumbAlreadyExist = breadCrumbs.find(subData => (subData.routerLink === this.dashboard));
      }
    }
    if (breadCrumbAlreadyExist) {
      rowIndex = breadCrumbs.findIndex((data) => (data === breadCrumbAlreadyExist));
      if (rowIndex !== undefined) {
        parentUrl = breadCrumbs[rowIndex].routerLink;
      }
    }
    return parentUrl;
  }

  setPageTitleConfig(envPortal) {
    this.pageTitleConfig = (envPortal) ? envPortal : {};
  }

  getPageTitleConfig() {
    return this.pageTitleConfig;
  }

  getPageLoadChecklist() {
    return this.pageLoadChangeChecklist;
  }

  setPageLoadChecklist(state: boolean) {
    this.pageLoadChangeChecklist.next(state);
  }

  csvToJson(data) {
    let parsedData = data.toString().split("\n");
    let result = [];
    let headers = parsedData[0].split(",");
    for (let i = 1; i < parsedData.length; i++) {
      let obj = {};
      let currentLine = parsedData[i].split(",");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentLine[j].replace(/"/g, "");
      }
      result.push(obj);
    }
    console.log(result);
    console.log(JSON.stringify(result));
    return JSON.stringify(result);
  }



}

